export class mdlVehicleDetailsCompRenewal {
    public VEHICLE_USAGE_EN: string;
    public VEHICLE_USAGE_AR: string;
    public MAKE_DESC_EN: string;
    public MAKE_DESC_AR: string;
    public MODEL_DESC_EN: string;
    public MODEL_DESC_AR: string;
    public VEHICLE_MANFYEAR: number;
    public VEHICLE_COLOR: string;
    public VEHICLE_FULLPLATENOAR: string;
    public PROPOSAL_EFFECTIVEDATE: string;
    public PROPOSAL_EXPIRYDATE: string;
    public INSURED_NAME: string;
    public INSURED_LICENCE_EXPIRY: string;
    public PLATE_TYPE_EN: string;
    public PLATE_TYPE_AR: string;
    public VEHICLE_TYPE_EN: string;
    public VEHICLE_TYPE_AR: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlVehicleDetailsCompRenewal.ts